import React from "react";
import { Box, Container, useMediaQuery } from "@mui/material";
import image1 from "../Images/image1.jpeg";
import image2 from "../Images/image2.jpeg";
import image3 from "../Images/image3.jpeg";
import image4 from "../Images/image4.jpeg";
import image5 from "../Images/image5.jpeg";
import image6 from "../Images/image6.jpeg";
import image7 from "../Images/image7.jpeg";
import image8 from "../Images/image8.jpeg";
import image9 from "../Images/image9.jpeg";
import image10 from "../Images/image10.jpeg";
import image11 from "../Images/image11.jpeg";

import { SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";

import StyledSwiper from "./SwiperSlider";

const swiperData = [
  image1,
  image2,
  image3,
  image4,
  image5,
  image6,
  image7,
  image8,
  image9,
  image10,
  image11,
];

const FeaturedSlider = () => {
  const matches = useMediaQuery("(max-width:960px)");

  return (
    <>
      <Box position="relative" width="100%">
        <Container maxWidth="xl">
          <StyledSwiper>
            {swiperData.map((item, index) => {
              return (
                <SwiperSlide key={index} style={{ borderRadius: "10%" }}>
                  <Box display="flex" justifyContent="center">
                    <img
                      src={item}
                      width={matches ? "90%" : "70%"}
                      style={{ borderRadius: "16px" }}
                      alt=""
                    />
                  </Box>
                </SwiperSlide>
              );
            })}
          </StyledSwiper>
        </Container>
      </Box>
    </>
  );
};

export default FeaturedSlider;
